import Crashlitics from "./Crashlitics";
class Logger {
  private static isDevEnv = import.meta.env.DEV;

  static debug(...args: unknown[]): void {
    if (!Logger.isDevEnv) return;
    console.log("🔵", ...args);
  }

  static info(...args: unknown[]): void {
    console.info("🟢", ...args);
  }

  static warn(...args: unknown[]): void {
    console.warn("🟠", ...args);
  }

  static error(...args: unknown[]): void {
    console.error("🔴", ...args);

    if (!Logger.isDevEnv) {
      Crashlitics.captureException(args);
    }
  }
}

export default Logger;
